module.exports = __webpack_public_path__ + "static/media/map_pfeil.b9240bb8.png";